import { zCorpAdminRowDto } from "@/types/company/corpAdmin.dto";
import { zCorpAdminDom } from "@/types/company/corpAdmin.domain";
export const CorpAdminMapper = {
    rowToDomain(raw) {
        const row = zCorpAdminRowDto.parse(raw);
        return zCorpAdminDom.parse({
            adminId: row.admin_id,
            email: row.email,
            fullName: row.full_name,
            phone: row.phone ?? null,
            status: row.status,
            blockedAt: row.blocked_at ?? null,
            blockReason: row.block_reason ?? null,
            createdAt: row.created_at,
            companyIds: row.company_ids ?? [],
            companyNames: (row.company_names ?? []).filter((name) => typeof name === "string"),
        });
    },
};
